module.exports = __webpack_public_path__ + "static/media/closeEN.4a5954ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/museum/closeEN.png
// module id = 1100
// module chunks = 0